/* eslint-disable */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.accordion__content');
    this.insetclose = el.querySelector('inset-close');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));

    if (this.insetclose) {
      this.insetclose.addEventListener('click', (e) => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();
    if (this.isClosing || !this.el.open) {
      if (this.el.classList.contains('nested-accordion')) {
        this.closeAll('nested');
      } else if (this.el.classList.contains('nested-nested-accordion')) {
        this.closeAll('nested-nested');
      } else {
        this.closeAll('all');
      }
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-in-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  closeAll(subAccordions) {
    let allAccordions;
    if (subAccordions == 'nested') {
      allAccordions = document.querySelectorAll('details.nested-accordion');
    } else if (subAccordions == 'nested-nested') {
      allAccordions = document.querySelectorAll('details.nested-nested-accordion');
    } else {
      allAccordions = document.querySelectorAll('details');
    }
    allAccordions.forEach(
      (accordionEl) => {
        accordionEl.removeAttribute('open');
      }
    );
  }
}

document.querySelectorAll('details.with-sliding').forEach((el) => {
  new Accordion(el);
});


const whenTransitionEnd = (element, property, timeout) => new Promise((resolve) => {
// Add an event listener to the element that fires when the transition ends
element.addEventListener('transitionend', function onTransitionEnd(event) {
  if (event.target !== element) return;
  if (event.propertyName !== property) return;

  element.removeEventListener('transitionend', onTransitionEnd);
  resolve(event);
});

// Ensure the promise resolves after the duration, even if the transition never fires
setTimeout(resolve, timeout);
});

function fostrGetFocusableElements(container) {
return Array.from(
  container.querySelectorAll(
    "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
  )
);
}

const fostrTrapFocusHandlers = {};

function fostrTrapFocus(container, elementToFocus = container) {
var elements = fostrGetFocusableElements(container);
var first = elements[0];
var last = elements[elements.length - 1];

fostrRemoveTrapFocus();

trapFocusHandlers.focusin = (event) => {
  if (
    event.target !== container &&
    event.target !== last &&
    event.target !== first
  )
    return;

  document.addEventListener('keydown', fostrTrapFocusHandlers.keydown);
};

fostrTrapFocusHandlers.focusout = function() {
  document.removeEventListener('keydown', fostrTrapFocusHandlers.keydown);
};

fostrTrapFocusHandlers.keydown = function(event) {
  if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
  // On the last focusable element and tab forward, focus the first element.
  if (event.target === last && !event.shiftKey) {
    event.preventDefault();
    first.focus();
  }

  //  On the first focusable element and tab backward, focus the last element.
  if (
    (event.target === container || event.target === first) &&
    event.shiftKey
  ) {
    event.preventDefault();
    last.focus();
  }
};

document.addEventListener('focusout', fostrTrapFocusHandlers.focusout);
document.addEventListener('focusin', fostrTrapFocusHandlers.focusin);

elementToFocus.focus();
}

function fostrRemoveTrapFocus(elementToFocus = null) {
document.removeEventListener('focusin', fostrTrapFocusHandlers.focusin);
document.removeEventListener('focusout', fostrTrapFocusHandlers.focusout);
document.removeEventListener('keydown', fostrTrapFocusHandlers.keydown);

if (elementToFocus) elementToFocus.focus();
}


class MainMenu extends HTMLElement {
constructor() {
  super();
  this.topLevelLink = this.querySelectorAll('.contains-sub-menu');
  this.subCategoryLink = this.querySelectorAll('.buly-main-menu__sub-link');
  this.subSubCategoryLink = this.querySelectorAll('.buly-main-menu__sub-sub-menu');
  this.subMenuBackLinks = this.querySelectorAll('.buly-main-menu__sub-back');

  this.topLevelLink.forEach(
    (link) => {
      link.addEventListener('click', this.showChildMenu.bind(this));
    }
  );

  this.subCategoryLink.forEach(
    (link) => {
      link.addEventListener('click', this.showCategoryMenu.bind(this));
    }
  );

  this.subMenuBackLinks.forEach(
    (link) => {
      link.addEventListener('click', this.closeSubMenu.bind(this));
    }
  );
}

closeSubMenu(e) {
  e.preventDefault();
  const header = e.target.parentNode;
  header.closest('.buly-main-menu__sub-menu').classList.remove('active');
  document.body.classList.remove('menu-sub-active');
}

showChildMenu(e) {
  e.preventDefault();
  const childMenuID = e.currentTarget.dataset.toggle;
  document.body.classList.add('menu-sub-active');
  const childMenu = this.querySelector(`#${childMenuID}`);
  childMenu.classList.add('active');
}

showCategoryMenu(e) {
  e.preventDefault();
  const childMenuID = e.currentTarget.dataset.toggle;
  const childMenu = this.querySelector(`#${childMenuID}`);

  this.subCategoryLink.forEach(
    (link) => {
      link.classList.remove('activated');
    }
  );

  this.subSubCategoryLink.forEach(
    (link) => {
      link.classList.remove('active');
    }
  );

  e.currentTarget.classList.add('activated');
  childMenu.classList.add('active');
}

}
customElements.define('fostr-modal-menu', MainMenu);


class togglePdpColor extends HTMLElement {
constructor() {
  super();
  this.currentColor = this.querySelector('.active-color');
  this.toggleButtons = this.querySelectorAll('.product-form__input--color input[type="radio"] + label');
  this.gallerySlides = document.querySelectorAll('.swiper-slide.buly-card-product');
  this.formVariantID = this.closest('.card-quickbuy')?.querySelector('[name="id"]');

  this.toggleButtons.forEach(
    (swatch) => {
      swatch.addEventListener('click', this.changeColor.bind(this));
    }
  );
}

changeColor(e) {
  const activeColor = e.target.title;
  var i = 0;

  this.currentColor.innerHTML = activeColor;
  if(this.formVariantID) {
    this.formVariantID.value = e.target.dataset.variant;
  }

  this.gallerySlides.forEach(
    (slide) => {
      if (slide.getAttribute('data-media-variants')) {
        const variantArr = slide.getAttribute('data-media-variants').split('|');

        variantArr.forEach(
          (name) => {
            if (name == activeColor) {
              this.moveToSlide(i);
              return;
            }
          }
        );
      }

      i++;
    }
  );
}

moveToSlide(i) {
  const pdpSwiper = document.querySelector('.buly-gallery-carousel').swiper;
  pdpSwiper.slideTo(i + 1, 500, true);
}

}
customElements.define('pdp-color-swatch', togglePdpColor);


class toggleVariant extends HTMLElement {
constructor() {
  super();
  this.currentVar = this.querySelector('.active-var');
  this.toggleButtons = this.querySelectorAll('.swiper-slide input[type="radio"] + label');
  this.gallerySlides = document.querySelectorAll('.swiper-slide.buly-card-product');

  this.toggleButtons.forEach(
    (swatch) => {
      swatch.addEventListener('click', this.changeVar.bind(this));
    }
  );

  if (this.classList.contains('Personnalisation')) {
    if(this.querySelector('input[value="Aucun"]')) {
      this.querySelector('input[value="Aucun"]').click();
    }
  }
}

changeVar(e) {

  const activeVar = e.target.getAttribute('data-option-value');
  var i = 0;

  this.currentVar.innerHTML = activeVar;

  this.gallerySlides.forEach(
    (slide) => {
      if (slide.getAttribute('data-media-variants')) {
        const variantArr = slide.getAttribute('data-media-variants').split('|');

        variantArr.forEach(
          (name) => {
            if (name == activeVar) {
              this.moveToSlide(i);
              return;
            }
          }
        );
      }

      i++;
    }
  );
}

moveToSlide(i) {
  const pdpSwiper = document.querySelector('.buly-gallery-carousel').swiper;
  pdpSwiper.slideTo(i + 1, 500, true);
}

}
customElements.define('pdp-variant-switch', toggleVariant);

/**
 * @deprecated Sticky atc block
 * We really need to refactor this component.
 */
class pdpStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyActive = false;
    if (document.querySelector('.value-props-and-wishlist')) {
      this.nextElement = document.querySelector('.value-props-and-wishlist');
    } else {
      this.nextElement = document.querySelector('.pdp-accordions');
    }

    // Create mutation observer to watch for DOM changes
    const observer = new MutationObserver(() => {
      this.setDimensions();
    });

    // Start observing this element for DOM changes
    observer.observe(this, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Initial dimensions setup
    this.setDimensions();

    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      if (this.stickyActive) {
        if (scrolled < this.triggerPoint) {
          this.removeSticky();
        }
      } else {
        if (scrolled > this.triggerPoint) {
          this.addSticky();
        }
      }
    });

    window.addEventListener('resize', () => {
      this.setDimensions();
    });
  }

  setDimensions = () => {
    // Get the element with data-ekoo attribute that is not empty
    const ekooElement = this.querySelector('[data-ekoo]:not(:empty)');
    
    // Get computed style height if element exists
    let ekooHeight = 0;
    if (ekooElement) {
      ekooHeight = ekooElement.getBoundingClientRect().height;
    }

    
    this.wrapperHeight = this.parentElement.offsetHeight + ekooHeight;
    this.triggerPoint = this.offsetTop + this.wrapperHeight;
  }

  addSticky() {
    if (window.innerWidth >= 990) return;

    this.parentElement.style.height = this.wrapperHeight + 'px'
    this.classList.add('stick');
    document.body.classList.add('sticky-add-to-cart');
    this.style.transform = "translateY(-100%)";
    this.stickyActive = true;
    document.querySelector('body').style.paddingBottom = this.wrapperHeight + 'px';
    document.getElementById('shopify-section-footer').style.paddingBottom = `${this.wrapperHeight}px`;
  }

  removeSticky() {
    this.style.transform = "translateY(0)";
    document.body.classList.remove('sticky-add-to-cart');
    this.stickyActive = false;
    if(this.nextElementSibling){
      this.nextElementSibling.style.paddingTop = 0;
    }
    this.classList.remove('stick');
    document.querySelector('body').style.paddingBottom = 0;
    document.getElementById('shopify-section-footer').style.paddingBottom = 0;
  }
}
customElements.define('sticky-atc-block', pdpStickyAtc);


class giftFlag extends HTMLElement {
constructor() {
  super();
  this.giftInput = this.querySelector('input');
  this.giftInput.addEventListener('change', this.changeGiftFlag.bind(this));
}

changeGiftFlag(event) {
  let isGift = '';
  if (event.target.checked) {
    isGift = 'Yes';
  }

  const giftFlag = {
    isgift: isGift
  };

  const body = JSON.stringify({
    attributes: giftFlag
  });

  return fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body })
  .then(response => response.json())
  .then(() => {
  })
  .catch(err => {
    console.error(err);
  });
}
}
customElements.define('gift-option', giftFlag);


class giftWrapMessage extends HTMLElement {
  constructor() {
    super();
    this.messageCntr = this.querySelector('order-message');
    this.msgInput = this.querySelector('textarea');
    this.charCount = this.querySelector('.order-message__characters');
    this.updateBtn = this.querySelector('.order-message__set-message');
    this.removeBtn = this.querySelector('.order-message__remove-message');
    this.messagePrice = this.querySelector('.order-message__price');
    this.msgInput.addEventListener('keyup', this.calcInputChar.bind(this));
    this.updateBtn.addEventListener('click', this.updateMessage.bind(this));
    this.removeBtn.addEventListener('click', this.removeMessage.bind(this));
    this.calcInputChar();
    this.checkButtonMessageExists();
    this.gwm2Element = document.getElementById('gwm2'); 
  }


  calcInputChar() {
    this.charCount.innerHTML = this.msgInput.value.length;
  }

  removeMessage(event) {
    event.target.disabled = true;
    this.msgInput.value = '';
      this.messageCntr.classList.remove('has-message');
      this.checkButtonMessageExists();
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }


  updateMessage(event) {
    event.target.disabled = true;
    const messageString = this.msgInput.value
    
      if (messageString.length > 0) {
        this.messageCntr.classList.add('has-message');
        document.getElementById('gwm2').style.display = "block";
        this.checkButtonMessageExists();
      } else {
        document.getElementById('gwm2').style.display = "none";
        this.messageCntr.classList.remove('has-message');
        this.checkButtonMessageExists();
      }
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }

  checkButtonMessageExists(){
    let updateButtonTextValue = false;
    let showRemoveMessageButton = false;
    
    if(this.messageCntr.classList.contains('has-message')) {
      showRemoveMessageButton = true;
    }
    this.showRemoveMessageButton(showRemoveMessageButton);
  }

  showRemoveMessageButton(showRemoveMessageButton) {
    if(showRemoveMessageButton == true) {
      this.removeBtn.classList.remove('hidden');
      this.updateBtn.classList.add('hidden-m');
      this.messagePrice.classList.add('order-message__price-valid');
      this.msgInput.disabled = true;
    } else {
      this.removeBtn.classList.add('hidden');
      this.updateBtn.classList.remove('hidden-m');
      this.messagePrice.classList.remove('order-message__price-valid');
      this.msgInput.disabled = false;
    }
  }

  updateButtonText(updateButtonTextValue){
    if(updateButtonTextValue == true) {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextUpdate
    } else {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextAdd
    }
  }
}
customElements.define('gift-wrap-message', giftWrapMessage);

class giftWrapMessage2 extends HTMLElement {
  constructor() {
    super();
    this.messageCntr = this.querySelector('order-message');
    this.msgInput = this.querySelector('#orderMsg2');
    this.charCount = this.querySelector('.order-message__characters');
    this.updateBtn = this.querySelector('.order-message__set-message');
    this.removeBtn = this.querySelector('.order-message__remove-message');
    this.messagePrice = this.querySelector('.order-message__price');    
    this.msgInput.addEventListener('keyup', this.calcInputChar.bind(this));
    this.updateBtn.addEventListener('click', this.updateMessage.bind(this));
    this.removeBtn.addEventListener('click', this.removeMessage.bind(this));
    this.calcInputChar();
    this.checkButtonMessageExists();
    this.gwm3Element = document.getElementById('gwm3');   
  }


  calcInputChar() {
    this.charCount.innerHTML = this.msgInput.value.length;
  }

  removeMessage(event) {
    event.target.disabled = true;
    this.msgInput.value = '';
      this.messageCntr.classList.remove('has-message');
      this.checkButtonMessageExists();
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }


  updateMessage(event) {
    event.target.disabled = true;
    const messageString = this.msgInput.value
    
      if (messageString.length > 0) {
        this.messageCntr.classList.add('has-message');       
        this.checkButtonMessageExists();
      } else {
        this.messageCntr.classList.remove('has-message');
        this.checkButtonMessageExists();
      }
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }

  checkButtonMessageExists(){
    let updateButtonTextValue = false;
    let showRemoveMessageButton = false;
    
    if(this.messageCntr.classList.contains('has-message')) {
      showRemoveMessageButton = true;
    }
    this.showRemoveMessageButton(showRemoveMessageButton);
  }

  showRemoveMessageButton(showRemoveMessageButton) {
    if(showRemoveMessageButton == true) {
      this.removeBtn.classList.remove('hidden');
      this.updateBtn.classList.add('hidden-m');
      this.messagePrice.classList.add('order-message__price-valid');
      this.msgInput.disabled = true;
    } else {
      this.removeBtn.classList.add('hidden');
      this.updateBtn.classList.remove('hidden-m');
      this.messagePrice.classList.remove('order-message__price-valid');
      this.msgInput.disabled = false;
    }
  }

  updateButtonText(updateButtonTextValue){
    if(updateButtonTextValue == true) {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextUpdate
    } else {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextAdd
    }
  }
}
customElements.define('gift-wrap-message2', giftWrapMessage2);

class giftWrapMessage3 extends HTMLElement {
  constructor() {
    super();
    this.messageCntr = this.querySelector('order-message');
    this.msgInput = this.querySelector('#orderMsg3');
    this.charCount = this.querySelector('.order-message__characters');
    this.updateBtn = this.querySelector('.order-message__set-message');
    this.removeBtn = this.querySelector('.order-message__remove-message');
    this.messagePrice = this.querySelector('.order-message__price');
    this.msgInput.addEventListener('keyup', this.calcInputChar.bind(this));
    this.updateBtn.addEventListener('click', this.updateMessage.bind(this));
    this.removeBtn.addEventListener('click', this.removeMessage.bind(this));
    this.calcInputChar();
    this.checkButtonMessageExists();
    this.gwm3Element = document.getElementById('gwm3');   
  }


  calcInputChar() {
    this.charCount.innerHTML = this.msgInput.value.length;
  }

  removeMessage(event) {
    event.target.disabled = true;
    this.msgInput.value = '';
      this.messageCntr.classList.remove('has-message');
      this.checkButtonMessageExists();
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }


  updateMessage(event) {
    event.target.disabled = true;
    const messageString = this.msgInput.value
    
      if (messageString.length > 0) {
        this.messageCntr.classList.add('has-message');       
        this.checkButtonMessageExists();
      } else {
        this.messageCntr.classList.remove('has-message');
        this.checkButtonMessageExists();
      }
      this.messageCntr.querySelector('summary').click();
      event.target.disabled = false;
  }

  checkButtonMessageExists(){
    let updateButtonTextValue = false;
    let showRemoveMessageButton = false;
    
    if(this.messageCntr.classList.contains('has-message')) {
      showRemoveMessageButton = true;
    }
    this.showRemoveMessageButton(showRemoveMessageButton);
  }

  showRemoveMessageButton(showRemoveMessageButton) {
    if(showRemoveMessageButton == true) {
      this.removeBtn.classList.remove('hidden');
      this.updateBtn.classList.add('hidden-m');
      this.messagePrice.classList.add('order-message__price-valid');
      this.msgInput.disabled = true;
    } else {
      this.removeBtn.classList.add('hidden');
      this.updateBtn.classList.remove('hidden-m');
      this.messagePrice.classList.remove('order-message__price-valid');
      this.msgInput.disabled = false;
    }
  }

  updateButtonText(updateButtonTextValue){
    if(updateButtonTextValue == true) {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextUpdate
    } else {
      this.updateBtn.textContent = window.cartStrings.updateBtnTextAdd
    }
  }
}
customElements.define('gift-wrap-message3', giftWrapMessage3);


class orderComment extends HTMLElement {
constructor() {
  super();
  this.msgInput = this.querySelector('#orderComment');
  this.updateBtn = this.querySelector('.order-comment__set-comment');

  this.updateBtn.addEventListener('click', this.updateComment.bind(this));
}

updateComment(e) {
  e.target.disabled = true;

  const cartNote = this.msgInput.value;
  const formData = { note: cartNote };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (cartNote.length > 0) {
      this.classList.add('has-comment');
    } else {
      this.classList.remove('has-comment');
    }
    this.querySelector('summary').click();
    e.target.disabled = false;
  })
  .catch((error) => {
    e.target.disabled = false;
    console.error(error.status,error);
  });
}
}
customElements.define('comment-block', orderComment);

class CollectionLayout extends HTMLElement {
constructor() {
  super();
  this.slimColLayoutBtn = document.getElementById('slimColLayout');
  this.standardColLayoutBtn = document.getElementById('standardColLayout');
  this.slimColLayoutBtn.addEventListener('click', (e) => this.changeLayout(e));
  this.standardColLayoutBtn.addEventListener('click', (e) => this.changeLayout(e));
}

changeLayout(e) {
  e.preventDefault();
  const id = e.currentTarget.id;
  if(id == 'slimColLayout') {
    document.getElementById('ProductGridContainer').classList.add('slim-layout');
  } else if (id == 'standardColLayout') {
    document.getElementById('ProductGridContainer').classList.remove('slim-layout');
  }
}

showChildMenu(e) {
  e.preventDefault();
  const childMenuID = e.target.dataset.toggle;
  const childMenu = document.getElementById(childMenuID);
  childMenu.classList.add('active');
}

showCategoryMenu(e) {
  e.preventDefault();
  const childMenuID = e.target.dataset.toggle;
  const childMenu = document.getElementById(childMenuID);
  const subChildMenu = document.getElementById(childMenuID);

  this.subCategoryLink.forEach(
    (link) => {
      link.classList.remove('activated');
    }
  );

  this.subSubCategoryLink.forEach(
    (link) => {
      link.classList.remove('active');
    }
  );

  e.target.classList.add('activated');
  childMenu.classList.add('active');
}

}

customElements.define('collection-layout', CollectionLayout);

// Birthday selector functionality has been migrated to Alpine.js component
// See: src/lib/components/registerComponent/registerComponent.ts

function fetchConfig(type = 'json') {
return {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
};
}

class ModalVideo extends HTMLElement {
constructor() {
  super();
  this.vidModal = this.querySelector('.video__modal');
  this.openButtons = this.querySelectorAll('.video__trigger');
  this.closeButton = this.querySelector('.button--close-modal');

  if (this.openButtons) {
    this.openButtons.forEach(
      (btn) => {
        btn.addEventListener('click', this.openVid.bind(this));
      }
    );
  }

  if (this.closeButton) {
    this.closeButton.addEventListener('click', (e) => this.closeVid(e));
  }
}

openVid(e) {
  e.preventDefault();
  if (this.querySelector('.video-block').classList.contains('video-block--Split')) {
    this.vidModal.classList.add('visible');
  } else {
    e.target.classList.add('hidden');
  }
  this.querySelector('video').play();
}

closeVid(e) {
  e.preventDefault();
  this.vidModal.classList.remove('visible');
}
}

customElements.define('video-player-modal', ModalVideo);


class CountrySwitcher extends HTMLElement {
constructor() {
  super();
  this.select = this.querySelector('select');
  this.options = this.querySelectorAll('select option');
  this.savedLocation = this.getLocation();

  this.setLocation();

  if (this.select) {
    this.select.addEventListener('change', this.changeLocation.bind(this));
  }
}

setLocation() {
  const options = Array.from(this.options);
  const customisationSelector = options.find(option =>
    option.value.includes(this.savedLocation)
  );
  if(!customisationSelector) return;
  this.select.value = customisationSelector.value;
}

getLocation() {
  return localStorage.getItem('buly-country-selected');
}

changeLocation(e) {
  e.preventDefault();
  const country = this.select.value;
  localStorage.setItem('buly-country-selected', country);
  location.reload();
  window.location.reload();
}
}

customElements.define('country-switcher', CountrySwitcher);


class fostrBisModal extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('button.close');
    this.submitButton = this.querySelector('button.btn-success');
    this.container = this.querySelector('.container');

    this.varId = this.dataset.variantId;

    this.closeButton.addEventListener('click', (e) => this.closeBisForm(e));
    this.submitButton.addEventListener('click', (e) => this.submitBisForm(e));
  }

  openBisForm(e) {
    this.container.style.display = 'block';
  }

  closeBisForm(e) {
    e.preventDefault();
    this.container.style.display = 'none';
  }

  submitBisForm(e) {
    e.preventDefault();
    const emailField = this.querySelector('#email-'+this.varId);

    if (emailField.value.length > 0 && emailField.validity.valid) {

      const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=UBN4LK';
      const data = {
        data:{
          type:"back-in-stock-subscription",
          attributes:{
            channels: ["EMAIL"],
            profile:{
              data:{
                type:"profile",
                attributes: {
                  email: emailField.value
                }
              }
            }
          },
          relationships:{
            variant:{
              data:{
                type:"catalog-variant",
                id: "$shopify:::$default:::"+ this.varId
              }
            }
          }
        }
      }
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-04-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(data)
      };

      fetch(url, options)
        .then(res => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          this.querySelector('button.btn-success').style.display = 'none';
          this.querySelector('.completed_message').style.display = 'block';
        })
        .catch(err => {
          console.error(err)
          this.querySelector('.error_message').style.display = 'block';
        });
    }else{
      this.querySelector('.error_message_email').style.display = 'block';
    }
  }
}
  
customElements.define('fostr-bis-modal', fostrBisModal);


class LanguagePicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="language_code"]');
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('language-picker', LanguagePicker)

class CountryPicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="country_code"]');
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('country-picker', CountryPicker)


class PreorderInterest extends HTMLElement {
  constructor() {
    super();
    this.launchBtn = this.querySelector('button');
    this.lang = document.querySelector('html').getAttribute('lang');

    if (this.launchBtn) {
      this.launchBtn.addEventListener('click', this.launchModal.bind(this));
    }
  }
  
  launchModal(e) {
    e.preventDefault();

    if (this.lang == 'fr') {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'SHMEGR']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WgCrzi']);
    }
  }
}
customElements.define('preorder-interest', PreorderInterest);

document.addEventListener('DOMContentLoaded', () => {

  const parentElement = document.querySelector('#cart-items-modal');
  const bagPrice = document.querySelector('#selectors-container').dataset.bagprice;
  parentElement.addEventListener('click', (event) => {
      if (event.target.closest('#OpenMiniCartSpecialAttentions')) {
        const selectors = document.querySelectorAll('.quantity-selector');
  const totalSB = document.querySelector('#totalSB');
      var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => { 
        data.items.forEach(element => {
          if (element.handle == "sac-shopping") {
            var variantId = element.variant_id;
            var variantQty = element.quantity;
              selectors.forEach((selector) => {
                const quantityToDisplay = selector.querySelector('.quantity_bag');
                const selectProdId = +quantityToDisplay.dataset.productid;
                if (variantId == selectProdId) {
                  quantityToDisplay.textContent = variantQty
                }
              })
          }
        });
       selectors.forEach((selector) => {
        const decreaseButton = selector.querySelector('.decrease');
        const increaseButton = selector.querySelector('.increase');
        const quantityDisplay = selector.querySelector('.quantity_bag');
        const selectProdId = +quantityDisplay.dataset.productid;
        let qty = +quantityDisplay.textContent;
        const updateQuantityInArray = (productId, quantity) => {
            const existingItemIndex = AllitemsArr.findIndex(item => item.id === productId);
            if (existingItemIndex !== -1) {
                // Mettre à jour la quantité si le produit existe déjà
                AllitemsArr[existingItemIndex].quantity = quantity;
            } else {
                // Ajouter le nouveau produit si ce n'est pas déjà fait
                AllitemsArr.push({  id: productId, quantity });
            }
            updateTotalQuantity
        };
  
        decreaseButton.addEventListener('click', () => {
            if (qty > 0) {
                qty--;
                quantityDisplay.textContent = qty;
                updateQuantityInArray(selectProdId, qty);
                updateTotalQuantity();
            }
            decreaseButton.disabled = qty === 0;
        });
  
        increaseButton.addEventListener('click', () => {
            qty++;
            quantityDisplay.textContent = qty;
            decreaseButton.disabled = false;
            updateQuantityInArray(selectProdId, qty);
            updateTotalQuantity();
            const incrClosDiv = totalSB.closest('div')
            if (!incrClosDiv.classList.contains('bag_selected')) {
              incrClosDiv.classList.add('bag_selected')
            }
        });
    });
      });
      const button = document.querySelector('#confirmSB');
      button.addEventListener('click', async () => {
        // Filtrer les éléments avec quantité 0 avant d'envoyer
        const filteredItems = AllitemsArr.filter(item => item.quantity > 0);
        updateTotalQuantity2();
    
        // Fonction pour ajouter des articles au panier
        async function addToCart() {
            let body = JSON.stringify({
                items: filteredItems, // Utiliser filteredItems ici
                attributes: falseAttribute,
                sections_url: window.location.pathname
            });
            var falseAttribute = {
              _foo: "IgnoreThisAttribute"
            }
            let body2 = JSON.stringify({
              attributes: falseAttribute,
              sections_url: window.location.pathname
          });
    
            let responseAdd = await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body });
            let dataAdd = await responseAdd.json();
            let falseUpdate = await fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body2 });
            let dataUpdate = await falseUpdate.json();
        }
    
        // Fonction pour mettre à jour les quantités dans le panier
        async function updateCartQuantities() {
            const transformedObject = AllitemsArr.reduce((obj, item) => {
                obj[item.id] = 0;
                return obj;
            }, {});
    
            let body = JSON.stringify({
                updates: transformedObject,
                sections_url: window.location.pathname
            });
    
            let responseUpdate = await fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body });
            let dataUpdate = await responseUpdate.json();
        }
    
        try {
            await updateCartQuantities();
            await addToCart();
        } catch (error) {
            console.error('Erreur lors des appels fetch:', error);
        }
    });
    var AllitemsArr = [];
    var elements = document.querySelectorAll('.quantity_bag');
    var total = 0;
    elements.forEach(function(element) {
      total += parseInt(element.textContent) || 0;
    });
    var X = total;

    const updateTotalQuantity = () => {
      var elements = document.querySelectorAll('.quantity_bag');
      var total = 0;
      elements.forEach(function(element) {
        total += parseInt(element.textContent) || 0;
      });
      const icondiv = document.querySelector('#MCSPC2')
      var totalqty = total;
      var bagpriceAdjust = parseFloat(bagPrice.replace(",", "."));
      var totalQuantity = totalqty * bagpriceAdjust; 
      var totalPrice = totalQuantity + '€';
      document.getElementById('totalSB').textContent = totalPrice;
      if (totalQuantity == 0) {
        totalSB.closest('div').classList.remove('bag_selected')
      }
  };
  const updateTotalQuantity2 = () => {
    var elements = document.querySelectorAll('.quantity_bag');
    var total = 0;
    elements.forEach(function(element) {
      total += parseInt(element.textContent) || 0;
    });
    const icondiv = document.querySelector('#MCSPC2')
    var totalqty = total;
    var bagpriceAdjust = parseFloat(bagPrice.replace(",", "."));
    var totalQuantity = totalqty * bagpriceAdjust; 
    var totalPrice = totalQuantity + '€';
    document.getElementById('PriceSB').textContent = totalPrice;
      document.getElementById('QtySB').textContent = totalqty;
      if (totalqty>0) {
        icondiv.classList.remove('hide_icon');
      } else {
        if (!icondiv.classList.contains('hide_icon')) {
          icondiv.classList.add('hide_icon');
        }
      };
};
    }
  });


});

document.addEventListener('DOMContentLoaded', () => {
  const MCSPC1Button = document.querySelector('#MCSPC1');
  const parentElement = document.querySelector('#cart-items-modal');
  const confirmCNButton = document.querySelector('#confirmCN');

  MCSPC1Button?.addEventListener('click', () => {
    // Récupérer les valeurs de qty2 et qty3
    let qty1 = 0;
    let qty2 = 0;
    let qty3 = 0;

    const orderMsg1 = document.querySelector('#orderMsg').value;
    const orderMsg2 = document.querySelector('#orderMsg2').value;
    const orderMsg3 = document.querySelector('#orderMsg3').value;

    if (orderMsg1.length > 0) {
      qty1 = 1;
    }

    if (orderMsg2.length > 0) {
      qty2 = 1;
    }

    if (orderMsg3.length > 0) {
      qty3 = 1;
    }


    // Vérifier si les valeurs sont égales à 1
    if (qty1 === 1) {
      // Supprimer la classe hidden de l'élément correspondant à qty1
      const elementQty1 = document.querySelector('#gwm1'); // Correction : utiliser #gwm1 au lieu de #gwm2
      if (elementQty1) {
        elementQty1.classList.remove('hidden');
      }
    }

    // Vérifier si les valeurs sont égales à 1
    if (qty2 === 1) {
      // Supprimer la classe hidden de l'élément correspondant à qty2
      const elementQty2 = document.querySelector('#gwm2');
      if (elementQty2) {
        elementQty2.classList.remove('hidden');
      }
      // Supprimer la classe hidden de l'élément correspondant à qty3
      const elementQty3 = document.querySelector('#gwm3');
      if (elementQty3) {
        elementQty3.classList.remove('hidden');
      }
    }

    if (qty3 === 1) {
      // Supprimer la classe hidden de l'élément correspondant à qty3
      const elementQty3 = document.querySelector('#gwm3');
      if (elementQty3) {
        elementQty3.classList.remove('hidden');
      }
    }
  });

  parentElement.addEventListener('click', (event) => { // Ajouter async ici
    if (event.target.matches('#confirmCN')) {
      const orderMsg = document.querySelector('#orderMsg').value;
      const orderMsg2 = document.querySelector('#orderMsg2').value;
      const orderMsg3 = document.querySelector('#orderMsg3').value;
      const ArrMsg = {
        ordermessage1: orderMsg,
        ordermessage2: orderMsg2,
        ordermessage3: orderMsg3
      };

      let qty1 = 0;
      let qty2 = 0;
      let qty3 = 0;
      if (orderMsg.length > 0) {
        qty1 = 1;
      }
      if (orderMsg2.length > 0) {
        qty2 = 1;
      }
      if (orderMsg3.length > 0) {
        qty3 = 1;
      }
      let qty = qty1 + qty2 + qty3;

      const QtyCN = document.querySelector('#QtyCN');
      const PriceCN = document.querySelector('#PriceCN');
      const PriceCNM2 = document.querySelector('#PriceCN');
      const icondiv = document.querySelector('#MCSPC1');
      const pricexqty = 5 * qty;


      QtyCN.textContent = 'quantity: ' + qty;
      PriceCN.innerHTML = pricexqty + '€';
      PriceCNM2.textContent = pricexqty + '€';

      if (qty > 0) {
        icondiv.classList.remove('hide_icon');
      } else {
        if (!icondiv.classList.contains('hide_icon')) {
          icondiv.classList.add('hide_icon');
        }
      }


      async function addCN1() {
        const itemToAdd1 = [{
          id: 47343018082642,
          quantity: 0
        }];
        const orderMsg = document.querySelector('#orderMsg').value;
        const orderMsg2 = document.querySelector('#orderMsg2').value;
        const orderMsg3 = document.querySelector('#orderMsg3').value;
        const ArrMsg = {
          ordermessage1: "",
          ordermessage2: "",
          ordermessage3: ""
        };
        const body1 = JSON.stringify({
          items: itemToAdd1,
          attributes: ArrMsg,
          sections_url: window.location.pathname
        });
        await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body: body1 })
        .then(response => response.json())
        .then(data => {
          return data;
        })
        .catch(err => {
          console.error(err);
        });
      }

      async function updateCN() {
        const itemsArr2 = {
          47343018082642: 0
        };
  
        const body2 = JSON.stringify({
          updates: itemsArr2,
          sections_url: window.location.pathname
        });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body: body2 })
        .then(response => response.json())
        .then(data => {
          
          return data;
        })
        .catch(err => {
          console.error(err);
        });
      }

      async function addCN2() {
        const orderMsg = document.querySelector('#orderMsg').value;
        const orderMsg2 = document.querySelector('#orderMsg2').value;
        const orderMsg3 = document.querySelector('#orderMsg3').value;
        const ArrMsg = {
          ordermessage1: orderMsg,
          ordermessage2: orderMsg2,
          ordermessage3: orderMsg3
        };
  
        let qty1 = 0;
        let qty2 = 0;
        let qty3 = 0;
        if (orderMsg.length > 0) {
          qty1 = 1;
        }
        if (orderMsg2.length > 0) {
          qty2 = 1;
        }
        if (orderMsg3.length > 0) {
          qty3 = 1;
        }
        let qty = qty1 + qty2 + qty3;
  
        const itemToAdd2 = [{
          id: 47343018082642,
          quantity: qty
        }];
        const body3 = JSON.stringify({
          items: itemToAdd2,
          attributes: ArrMsg,
          sections_url: window.location.pathname
        });
        await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body: body3 })
        .then(response => response.json())
        .then(data => {
        
        return data;
        })
        .catch(err => {
          console.error(err);
        });
      }

      async function updateTryCN() {
      try {
        await addCN1();
        await delay(3000);
        await updateCN();
        await delay(3000);
        await addCN2();
        await delay(3000);
      } catch (err) {
        console.error(err);
      }
    }
    updateTryCN();
  }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  // Bouton pour confirmer la sélection (et retour modal 2)
  const button = document.querySelector('#confirmIGW');
  // On selectionne l'id de la div la plus haute du contenu du Cart, mais qui ne se re-render pas, pour pouvoir écouter les évènements à l'intérieur malgré les re render
  const parentElement = document.querySelector('#cart-items-modal');

  parentElement.addEventListener('click', (event) => {
    // permet d'écouter les clicks sur notre bouton même s'il y a eu un re render du coup
    if (event.target.matches('#confirmIGW')) {

      async function updateIGW() {
      const ArrToZero = {}
      let cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json());

      for (const element of cartContents.items) {
        var variant = element.variant_id;
          if (variant == 47343046754642) {
            var key = element.key;
            ArrToZero[key] = 0; // Ajouter la clé et la valeur 0 à l'objet
          }
      }
      const body = JSON.stringify({
        updates: ArrToZero,
        sections_url: window.location.pathname
      });

        await fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body })
        .then(response => response.json())
        .then(data => {
          return data;
        })
        .catch(err => {
          console.error(err);
        });
    }

        async function addIGW() {
        // on cherche le nombre de produits affichés dans notre modale
        const countInDiv = document.querySelectorAll('#IGW-content gift-wrap-message').length;
        var Arr = [];
        var ArrToAdd = [];
        var prodMsg = "Oui";
        var selectorId = '#IGW-product-message'
        // pour chaque produit affiché 
        for (let i = 0; i < countInDiv; i++) {
          // selectorId récupère l'id de chaque ligne (on affiche l'id en liquid dans une loop également pour ajouter le numéro de la ligne à la fin de l'id)
          selectorId = '#IGW-product-message'+i
          // on récupère des data qu'on a rentré dans la balise html qui nous servent pour la suite
          var prop = document.querySelector(selectorId)?.dataset.properties
          var title = document.querySelector(selectorId)?.dataset.title
          var keyHsh = document.querySelector(selectorId)?.dataset.key
          prodMsg = document.querySelector(selectorId)?.value;
          // on créé une variable contenant l'id unique keyHsh et le contenu du message rentré dans l'input
          var content = keyHsh + "/" + prodMsg
          if (prodMsg.length > 0) {
            // ici une var qui sera affichée (et servira pour le traitement de l'order notamment). Doit pouvoir identifier chaque produit, donc Title + property du produit + Message rentrée dans l'input pour l'emballage
            var toPush = title + "/" + prop + "/" + prodMsg + "/" + keyHsh;
            Arr.push(toPush);
          }
      };
      var y = 0;
      // On se serre de notre Arr pour ajouter la Personnalisation, mais ici il y a une erreur car Content sera toujours le même ici si on ajoute plusieurs produits.
      Arr.forEach(element => {
            y = y + 1;
            let contentElem = element.split("/");
            let titleElem = contentElem[0];
            let propElem = contentElem[1];
            let msgElem = contentElem[2];
            let keyElem = contentElem[3];
            var forFoo = keyElem + "/" + msgElem;
        const property = { 
          'Calligraphie': msgElem,
          'Title': titleElem,
          '_foo': forFoo,
          '_property': propElem
            }
        const itemToAdd = {
          id: 47343046754642,
          quantity: 1,
          properties: property
        };
        ArrToAdd.push(itemToAdd)
      });
      const icondiv = document.querySelector('#MCSPC3');
      document.getElementById('QtyIGW').textContent = y;
      if (y>0) {
        icondiv.classList.remove('hide_icon');
      } else {
        if (!icondiv.classList.contains('hide_icon')) {
          icondiv.classList.add('hide_icon');
        }
      };
      // pareil ici il y a une erreur car il n'y a qu'un seul body qui en résulte, donc au final un seul add to cart.
      const body = JSON.stringify({
        items: ArrToAdd,
        sections_url: window.location.pathname
      });
    await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then(response => response.json())   
    .then(data => {
          return data;
    })     
    .catch(err => {
      console.error(err);
    });
    }

    async function addIGW2() {
      const itemToAdd = [{
        id: 47343046754642,
        quantity: 1
      }];
      
    // pareil ici il y a une erreur car il n'y a qu'un seul body qui en résulte, donc au final un seul add to cart.
    const body = JSON.stringify({
      items: itemToAdd,
      sections_url: window.location.pathname
    });
  await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then(response => response.json())   
  .then(data => {
        return data;
  })     
  .catch(err => {
    console.error(err);
  });
  }

    async function updateTryIGW() {
    try {
      await addIGW2();
      await updateIGW();
      await addIGW();
  } catch (error) {
      console.error('Erreur lors des appels fetch:', error);
  }
      }

      updateTryIGW();
}


  
// ce code la sert à faire le lien entre ce qu'il y a au panier et le contenu de notre modal. 
// on veut le mettre à jour dans on ouvre la modal 2 pour que ce soit fluide sur la modal 3
if (event.target.closest('#OpenMiniCartSpecialAttentions')) {
const countInDiv = document.querySelectorAll('#IGW-content gift-wrap-message').length;
  var Arr2 = [];
    // le fameux fetch qui va cherche tout le contenu du panier
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      // on boucle pour chaque item dans le panier
      data.items.forEach(element => {
        var properties = element.properties
        for (let key in properties) {
          if (properties.hasOwnProperty(key)) {
            // si une des property dans properties s'appelle _foo!
            if (key === "_foo") {
              var test2 = '#IGW-product-message'
              for (let i = 0; i < countInDiv; i++) {
                test2 = '#IGW-product-message'+i
                // on vient recup la key du variant, qu'on a rentré dans data-key dans la balise html
                var keyHsh2 = document.querySelector(test2)?.dataset.key

              // content = le contenu de _foo (qui pour rappel est: Key / Message)
              var content = properties[key];
              let contents = content.split("/");
              let keyHash = contents[0];
              let msgValue = contents[1];
              // si la key de l'item du panier = la key dans data-key de la balise html de notre variant de la modal
              if (keyHsh2 === keyHash) {
                // on vient écrire le contenu du message présent dans le _foo dans l'input de notre variant
                var valueId = document.querySelector(test2);
                valueId.value = msgValue
                var commonAncestor = valueId.closest('order-message');
                var updateBtn = commonAncestor.querySelector('.order-message__set-message');
                var removeBtn = commonAncestor.querySelector('.order-message__remove-message');
                var messagePrice = commonAncestor.querySelector('.order-message__price');
                removeBtn.classList.remove('hidden');
                updateBtn.classList.add('hidden-m');
                messagePrice.classList.add('order-message__price-valid');
                // on disable la zone de texte pour que le client ne puisse que cliquer sur Remove
                valueId.disabled = true;
              }
            } 
          }
          } 
        }
      })
    });
  }
});
})


document.addEventListener('DOMContentLoaded', () => {
  // Bouton pour confirmer la sélection (et retour modal 2)
  const button = document.querySelector('#confirmJGW');
  // On selectionne l'id de la div la plus haute du contenu du Cart, mais qui ne se re-render pas, pour pouvoir écouter les évènements à l'intérieur malgré les re render
  const parentElement = document.querySelector('#cart-items-modal');

  parentElement.addEventListener('click', (event) => {
    // permet d'écouter les clicks sur notre bouton même s'il y a eu un re render du coup
    if (event.target.matches('#confirmJGW')) {

      async function updateJGW() {
      const ArrToZero = {}
      let cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json());

      for (const element of cartContents.items) {
        var variant = element.variant_id;
          if (variant == 47430233915730) {
            var key = element.key;
            ArrToZero[key] = 0; // Ajouter la clé et la valeur 0 à l'objet
          }
      }
      const body = JSON.stringify({
        updates: ArrToZero,
        sections_url: window.location.pathname
      });

        await fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body })
        .then(response => response.json())
        .then(data => {
          return data;
        })
        .catch(err => {
          console.error(err);
        });
    }

        async function addJGW() {
        // on cherche le nombre de produits affichés dans notre modale
        const countInDiv = document.querySelectorAll('#JGW-content gift-wrap-message').length;
        var Arr = [];
        var ArrToAdd = [];
        var prodMsg = "Oui";
        var selectorId = '#JGW-product-message'
        // pour chaque produit affiché 
        for (let i = 0; i < countInDiv; i++) {
          // selectorId récupère l'id de chaque ligne (on affiche l'id en liquid dans une loop également pour ajouter le numéro de la ligne à la fin de l'id)
          selectorId = '#JGW-product-message'+i
          // on récupère des data qu'on a rentré dans la balise html qui nous servent pour la suite
          var prop = document.querySelector(selectorId)?.dataset.properties
          var title = document.querySelector(selectorId)?.dataset.title
          var keyHsh = document.querySelector(selectorId)?.dataset.key
          var priceOne = document.querySelector(selectorId)?.dataset.price
          prodMsg = document.querySelector(selectorId)?.value;
          // on créé une variable contenant l'id unique keyHsh et le contenu du message rentré dans l'input
          var content = keyHsh + "/" + prodMsg
          if (prodMsg.length > 0) {
            // ici une var qui sera affichée (et servira pour le traitement de l'order notamment). Doit pouvoir identifier chaque produit, donc Title + property du produit + Message rentrée dans l'input pour l'emballage
            var toPush = title + "/" + prop + "/" + prodMsg + "/" + keyHsh;
            Arr.push(toPush);
          }
      };
      var y = 0;
      // On se serre de notre Arr pour ajouter la Personnalisation, mais ici il y a une erreur car Content sera toujours le même ici si on ajoute plusieurs produits.
      Arr.forEach(element => {
            y = y + 1;
            let contentElem = element.split("/");
            let titleElem = contentElem[0];
            let propElem = contentElem[1];
            let msgElem = contentElem[2];
            let keyElem = contentElem[3];
            var forFoo = keyElem + "/" + msgElem;
        const property = { 
          'Calligraphie': msgElem,
          'Title': titleElem,
          '_fooJP': forFoo,
          '_property': propElem
            }
        const itemToAdd = {
          id: 47430233915730,
          quantity: 1,
          properties: property
        };
        ArrToAdd.push(itemToAdd)
      });
      const icondiv = document.querySelector('#MCSPC4');
      document.getElementById('QtyJGW').textContent = y;
      var priceJGW = priceOne * y
      document.getElementById('PriceJGW').textContent = priceJGW + "€";
      if (y>0) {
        icondiv.classList.remove('hide_icon');
      } else {
        if (!icondiv.classList.contains('hide_icon')) {
          icondiv.classList.add('hide_icon');
        }
      };
      // pareil ici il y a une erreur car il n'y a qu'un seul body qui en résulte, donc au final un seul add to cart.
      const body = JSON.stringify({
        items: ArrToAdd,
        sections_url: window.location.pathname
      });
    await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then(response => response.json())   
    .then(data => {
          return data;
    })     
    .catch(err => {
      console.error(err);
    });
    }

    async function addJGW2() {
      const itemToAdd = [{
        id: 47430233915730,
        quantity: 1
      }];
      
    // pareil ici il y a une erreur car il n'y a qu'un seul body qui en résulte, donc au final un seul add to cart.
    const body = JSON.stringify({
      items: itemToAdd,
      sections_url: window.location.pathname
    });
  await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then(response => response.json())   
  .then(data => {
        return data;
  })     
  .catch(err => {
    console.error(err);
  });
  }

    async function updateTryJGW() {
    try {
      await addJGW2();
      await updateJGW();
      await addJGW();
  } catch (error) {
      console.error('Erreur lors des appels fetch:', error);
  }
      }

      updateTryJGW();
}


  
// ce code la sert à faire le lien entre ce qu'il y a au panier et le contenu de notre modal. 
// on veut le mettre à jour dans on ouvre la modal 2 pour que ce soit fluide sur la modal 3
if (event.target.closest('#OpenMiniCartSpecialAttentions')) {
const countInDiv2 = document.querySelectorAll('#JGW-content gift-wrap-message').length;
  var Arr2 = [];
    // le fameux fetch qui va cherche tout le contenu du panier
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      // on boucle pour chaque item dans le panier
      data.items.forEach(element => {
        var properties = element.properties
        for (let key in properties) {
          if (properties.hasOwnProperty(key)) {
            // si une des property dans properties s'appelle _foo!
            if (key === "_fooJP") {
              var test2 = '#JGW-product-message'
              for (let i = 0; i < countInDiv2; i++) {
                test2 = '#JGW-product-message'+i
                // on vient recup la key du variant, qu'on a rentré dans data-key dans la balise html
                var keyHsh2 = document.querySelector(test2)?.dataset.key

              // content = le contenu de _foo (qui pour rappel est: Key / Message)
              var content = properties[key];
              let contents = content.split("/");
              let keyHash = contents[0];
              let msgValue = contents[1];
              // si la key de l'item du panier = la key dans data-key de la balise html de notre variant de la modal
              if (keyHsh2 === keyHash) {
                // on vient écrire le contenu du message présent dans le _foo dans l'input de notre variant
                var valueId = document.querySelector(test2);
                valueId.value = msgValue
                var commonAncestor = valueId.closest('order-message');
                var updateBtn = commonAncestor.querySelector('.order-message__set-message');
                var removeBtn = commonAncestor.querySelector('.order-message__remove-message');
                var messagePrice = commonAncestor.querySelector('.order-message__price');
                removeBtn.classList.remove('hidden');
                updateBtn.classList.add('hidden-m');
                messagePrice.classList.add('order-message__price-valid');
                // on disable la zone de texte pour que le client ne puisse que cliquer sur Remove
                valueId.disabled = true;
              }
            } 
          }
          } 
        }
      })
    });
  }
});
})


  function simulateLoading(buttonId) {
    const confirmButton = document.getElementById(buttonId);

    // Ajouter la classe 'loading'
    confirmButton.classList.add('loading-modal-3');

    // Sauvegarder le contenu original du bouton
    const originalContent = confirmButton.innerHTML;

    // Remplacer le contenu par 'Loading ...'
    confirmButton.innerHTML = 'Loading ...';

    // Attendre 3 secondes
    setTimeout(() => {
      // Restaurer le contenu initial
      confirmButton.innerHTML = originalContent;

      // Retirer la classe 'loading'
      confirmButton.classList.remove('loading-modal-3');
    }, 3000); // 3000 millisecondes = 3 secondes
  }